export const getCachedActivityProfile = backendService => {
  try {
    return backendService?.getUser?.() || null;
  } catch {
    return null;
  }
};

export const canStartInitialActivityRetry = (requestActive) => !requestActive;

export const getActivityStartupRequestPlan = ({ primaryActivitiesSettled }) => ({
  primaryFeed: true,
  identity: true,
  membership: true,
  secondaryHydration: Boolean(primaryActivitiesSettled),
});

// Version zero is the mount-time read. A positive version represents a
// completed dojo/profile mutation and must never join a request that began
// before that mutation.
export const shouldShareStartupProfileRequest = dojoChangeVersion => dojoChangeVersion === 0;

export const isLatestStartupRequest = (requestId, latestRequestId) => requestId === latestRequestId;

// The coach slot has no business waiting on the recommendation request: that
// call feeds an insight inside the already-mounted Coach surface, not the
// surface's identity. Only identity (profile) and membership (dojo status)
// decide which Coach surface to render, so those are the only two gates.
export const getActivityStartupPresentation = ({
  initialLoadComplete,
  activityLoadError,
  activityCount,
  profileSettled,
  dojoStatusLoaded,
}) => ({
  activitySlot: !initialLoadComplete
    ? 'loading'
    : activityLoadError && activityCount === 0
      ? 'error'
      : 'content',
  coachSlot: !profileSettled
    ? 'identity-loading'
    : !dojoStatusLoaded
      ? 'context-loading'
      : 'content',
});
